import React from 'react';
import PropTypes from 'prop-types';

export const Subheader = ({children}) => (
    <h2 className="form-subheader">{children}</h2>
);
Subheader.propTypes = () => ({
    children: PropTypes.element.isRequired,
});
